<!--
 * @Description:
 * @Date: 2021-09-28 17:11:48
-->
<template>
  <component
    ref="addEdit"
    class="xrk-project-container"
    :is="editName"
    :key="key"
    @resetRuleForm="resetRuleForm"
  ></component>
</template>
<script>
import { judge } from '@/Mixin/judge';
import { mapState } from 'vuex';
import compareObj from '@/tools/deepCompare.js';
const components = {};
// 详情页面必须有name属性，必须在child文件下，文件名为add-edit。
// 为了兼容之前写法与name不要带有Detail，在此处进行拼接
// 详情要与import { projectAllList } from '@/config/staticData';同步
const files = require.context('../components', true, /add-edit.vue$/);
files.keys().forEach(fileName => {
  const curFile = files(fileName).default;
  const curFileName = curFile.name + 'Detail';
  if (/child/.test(fileName)) {
    components[curFileName] = curFile;
  }
});
export default {
  name: 'projectClassifyContainer',
  components,
  mixins: [judge],
  data() {
    return {
      key: 1,
      addEditForm: {}
    };
  },
  computed: {
    ...mapState({
      editName: state => state.homeProject.editName,
      projectId: state => state.homeProject.id,
      type: state => state.homeProject.type
    })
  },
  methods: {
    resetRuleForm(addEditForm) {
      this.addEditForm = JSON.parse(JSON.stringify(addEditForm));
    }
  },

  beforeRouteLeave(to, from, next) {
    /*
      对比项目编辑是否有更改且没保存
      确认离开当前页面则清除缓存
    */
    const saveSure = compareObj.compare(
      JSON.parse(JSON.stringify(this.addEditForm)),
      JSON.parse(JSON.stringify(this.$refs['addEdit'].ruleForm)),
      ['questionnaireId', 'channelId'],
      false
    );

    const allowRouterName = ['edit-next', 'questionEdit', 'sceneEdit', 'edit'];
    if (!allowRouterName.includes(to.name) && !saveSure) {
      // 如果点击浏览器的后退是没办法阻止后退行为的，虽然会走 beforeRouteLeave 这个钩子，但需要使用 confirm 阻塞
      if (this.$route.fullPath !== window.location.href.split('/#')[1]) {
        window.confirm('当前页面未保存是否继续跳转?')
          ? next()
          : window.history.forward();
        return;
      }

      this.$confirm('当前页面未保存是否继续跳转', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem(`${this.projectId}-detail`);
        next();
      });
    } else {
      if (!allowRouterName.includes(to.name)) {
        sessionStorage.removeItem(`${this.projectId}-detail`);
      }
      next();
    }
  },
  watch: {
    '$route.query.id': {
      handler() {
        // 项目id变化，更新组件
        this.key += 1;
      },
      deep: true
    }
  }
};
</script>
<style lang="scss">
$submitH: 70px;
/*高级form*/
.xrk-project {
  &-container {
    padding-bottom: $submitH;
  }

  &-form {
    display: flex;
    justify-content: space-around;
    & > div {
      flex: 1;
    }
    & > div:nth-child(1) {
      //overflow: hidden;
      margin-right: 0px;
      position: relative;
    }
    //& > div:nth-child(1)::after {
    //  position: absolute;
    //  right: -15px;
    //  top: 0;
    //  content: '';
    //  display: block;
    //  height: 100%;
    //  border-left: 1px dashed rgb(222, 215, 215);
    //  //margin: 0 16px;
    //  float: left;
    //}
  }

  &-footer {
    position: fixed;
    bottom: 0;
    right: 0;
    width: calc(100vw - 200px);
    background: #fff;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 5px -2px 5px #e3e3e3;
  }
}
</style>
